import {
  Dispatch,
  SetStateAction,
  ReactNode,
  createContext,
  useState,
  useMemo,
} from "react";

interface Context {
  selectedRange: string;
  setSelectedRange: Dispatch<SetStateAction<string>>;
}

export const SelectedTimeRangeContext = createContext<Context>({
  selectedRange: "all", // provide a default value
  setSelectedRange: () => {}, // provide a default function
});

interface SelectedTimeRangeProps {
  children: ReactNode;
}

export const SelectedTimeRangeProvider = ({
  children,
}: SelectedTimeRangeProps) => {
  const [selectedRange, setSelectedRange] = useState<string>("all");

  const context = useMemo(
    () => ({
      selectedRange,
      setSelectedRange,
    }),
    [selectedRange, setSelectedRange]
  );

  return (
    <SelectedTimeRangeContext.Provider value={context}>
      {children}
    </SelectedTimeRangeContext.Provider>
  );
};
